import { useEffect, useState } from 'react';
import '../styles/theme.css';
import { fetchHomeSlidesPublic } from '../lib/homeSlides';
import { getFileUrl } from '../lib/pb';

const SLIDES = [
  {
    id: 'symphonie',
    image: '/images/portail.jpg',
    title: 'Configurez dès maintenant votre portail AEF32',
    subtitle: 'Des solutions sur mesure pour sécuriser et embellir vos extérieurs.',
    ctaLabel: 'Je configure mon projet',
    ctaHref: '/contact',
  },
  {
    id: 'automatismes',
    image: '/images/portail2.jpg',
    title: 'Automatismes fiables et durables',
    subtitle: 'Motorisations adaptées à vos usages quotidiens.',
    ctaLabel: 'Parler de mon projet',
    ctaHref: '/contact',
  },
  {
    id: 'services',
    image: '/images/portail3.jpg',
    title: 'Accompagnement de A à Z',
    subtitle: 'Conseil, installation et maintenance par des spécialistes.',
    ctaLabel: 'Découvrir nos services',
    ctaHref: '/services',
  },
];

export default function HeroSlider() {
  const [index, setIndex] = useState(0);
  const [dbSlides, setDbSlides] = useState([]);
  const slides = dbSlides.length
    ? dbSlides.map(s => ({
      id: s.id,
      image: s.image ? getFileUrl(s, s.image) : '',
      title: s.title || '',
      subtitle: s.subtitle || '',
      ctaLabel: s.cta_label || s.ctaLabel || '',
      ctaHref: s.cta_href || s.ctaHref || '#',
    }))
    : SLIDES;

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % (slides.length || 1));
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const list = await fetchHomeSlidesPublic();
        if (!cancelled) setDbSlides(list || []);
      } catch {
        if (!cancelled) setDbSlides([]);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const current = slides[index % slides.length];

  const goTo = (i) => {
    const len = slides.length || SLIDES.length;
    setIndex((i + len) % len);
  };

  return (
    <section className="hero-slider">
      <div className="hero-slider-inner">
        <button
          type="button"
          className="hero-arrow hero-arrow-left"
          aria-label="Slide précédente"
          onClick={() => goTo(index - 1)}
        >
          ‹
        </button>
        <button
          type="button"
          className="hero-arrow hero-arrow-right"
          aria-label="Slide suivante"
          onClick={() => goTo(index + 1)}
        >
          ›
        </button>
        <div
          className="hero-slide"
          style={current.image ? { backgroundImage: `url(${current.image})` } : undefined}
        >

          {/* Option 1: Sceau de Qualité */}
          <div className="hero-seal">
            <div className="hero-seal-flag" />
            <div className="hero-seal-text">Fabriqué<br />en France</div>
          </div>

          <div className="hero-slide-overlay">
            <div className="hero-slide-content">
              <h1>{current.title}</h1>
              {current.subtitle && <p>{current.subtitle}</p>}
              {current.ctaLabel && (
                <a href={current.ctaHref} className="btn filled">
                  {current.ctaLabel}
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="hero-slider-dots" aria-label="Changer de slide">
          {slides.map((s, i) => (
            <button
              key={s.id}
              type="button"
              className={"hero-dot" + (i === index ? ' is-active' : '')}
              onClick={() => goTo(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
